// src/hooks/useWinbackStats.js
import { useState, useEffect, useCallback } from 'react';
import { get } from '../helpers/apiHelper';

export const useWinbackStats = (marcaId) => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadStats = useCallback(async () => {
        if (!marcaId) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await get(`clientes/winback/stats/${marcaId}`);
            setStats(response);
        } catch (err) {
            console.error('Error loading winback stats:', err);
            setError(err.message);
            // Set default stats on error
            setStats({
                totalCampaigns: 0,
                sent: 0,
                converted: 0,
                conversionRate: 0,
                avgDaysToConvert: 0,
                bySegment: {},
                byUrgency: {}
            });
        } finally {
            setLoading(false);
        }
    }, [marcaId]);

    useEffect(() => {
        loadStats();
    }, [loadStats]);

    return {
        stats,
        loading,
        error,
        refresh: loadStats
    };
};

